<div class="table-container m-t-12">
  <mc-table
    data-cy="work-order-list"
    [data]="data"
    fit="small"
    [columns]="columns"
    nowrap="true"
    sortmanual
    sortdefaultdirection="ascending"
    (sortchange)="onSortDirectionChange($event)"
    sortdefaultdirection="ascending"
    tabularFigures="true"
    headersticky
    height="100%">
    @for (row of data; track row; let i = $index) {
      <div slot="{{ row.id }}_maintenanceOrderNumber" class="pure-g">
        <a [routerLink]="[urlNavigate, row.maintenanceOrderNumber]">{{ row.maintenanceOrderNumber }} </a>
        @if (row.isOnHold) {
          <mc-tooltip appearance="neutral-default" style="margin-left: 5px">
            <mc-icon slot="trigger" icon="pause-circle" class="on-hold"></mc-icon>
            <div>On hold</div>
          </mc-tooltip>
        }
      </div>
      @if (row.isPriority) {
        <div slot="{{ row.id }}_priorityFlag" class="priority-flag">
          <mc-tooltip appearance="neutral-default">
            <mc-icon slot="trigger" icon="flag"></mc-icon>
            <div>High priority</div>
          </mc-tooltip>
        </div>
      }
    }
  </mc-table>
</div>
<div class="m-t-4 mds-text--small-light">{{ data?.length ?? 0 }} items</div>
